export var BUTTON_SIZES_MAP = {
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
    '2XL': '2xl',
};
export var isValidButtonSize = function (size) {
    return Object.values(BUTTON_SIZES_MAP).includes(size);
};
export var BUTTON_HIERARCHY_MAP = {
    PRIMARY: 'Primary',
    SECONDARY_GRAY: 'Secondary gray',
};
export var BUTTON_ICON_MAP = {
    DEFAULT: 'Default',
    LEADING: 'Leading',
    ONLY: 'Only',
};
